import * as React from 'react';
import Table from './tableworkers';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import Tablereport from './tablereportprint';
import Person from './images/Ellipse77.png';
import Logo from './images/FS229201First School.jpg';
import Avatar from '@mui/material/Avatar';
import Imagereplace from './images/Ellipse77.png';
import { useSelector } from 'react-redux';
import { getTermDisplay } from './utils/termUtils';

import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";


class Printpage extends React.Component {

    render(){

  const chosen = this.props.data
  const students = this.props.students
  const selectedterm = this.props.term
  const Class_ = this.props.Class_
  const schooldata = this.props.schooldata[0]
  // Toggleable display options (defaults match previous behaviour)
  const {
    showPosition = true,
    showGradePoint = true,
    showAttendance = true,
    showClassPosition = true,
    showAggregate = true,
    showPromotion = true,
    showDomainAssessment = true,
    showToddlerAssessment = false,
    roundValues = false,
    specialExams = false
  } = this.props
  const showPositionFlag = showClassPosition || showPosition
  const dt = new Date()
  const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
  const day = dt.getUTCDate();
  const month = String(dt.getMonth() + 1).padStart(2, '0');
  const year = dt.getFullYear();
  const date = year + "-" + month + "-" + day;
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    
  var totalothers=0

  const adder=(value)=>{
totalothers += parseFloat(value)
  }
  
  const formatNumber = (val) => {
    const num = Number(val)
    if (Number.isNaN(num)) return val
    return roundValues ? Math.round(num) : num
  }
  
  return (
        <div>

        <div className='pagebreak'>
        <Container style={{padding:0}}  >
     
                <div style={{marginTop:"4px"}}> 

                <div style={{textAlign:"center"}}>
             <br/>
                <Grid container style={{marginBottom:"10px"}}>
<Grid xs={8}>
  
    <img src={"https://thesis1995revolution0268005074.sisrevolution.com/sisrevolution1995/routes/logothumb/"+schooldata.image} width="80px" alt="schoologo"/> <br/>
    <h4 style={{margin:4}}>  {(schooldata.schoolname).toUpperCase()} </h4>
    <h5 style={{margin:4}}>  {(schooldata.address).toUpperCase()} </h5>
    <h5 style={{margin:4}}>  {(schooldata.contact)} </h5>


</Grid>
<Grid xs={4} style={{borderLeft:"solid", borderWidth:"0.1px", borderColor:"lightgray", textAlign:"center"}}>
    <div style={{textAlign:"center",  alignItems:"center", display:"flex", justifyContent:"center", width:"100%"}}>
<Avatar style={{  width:100, height:100, border: "solid", borderWidth:"0px", borderColor: "white", marginTop:5, marginBottom:"8px" }} alt={chosen.lastname} src={"https://thesis1995revolution0268005074.sisrevolution.com/sisrevolution1995/routes/thumbnail/"+chosen.image ? "https://thesis1995revolution0268005074.sisrevolution.com/sisrevolution1995/routes/thumbnail/"+chosen.image:Imagereplace} />
</div>
<div>
 <small> 
            <b>{(chosen.lastname).toUpperCase()+" "+(chosen.othernames).toUpperCase()}</b> <br/>
          
            <b>ID : {chosen.id}</b>
            </small>
            </div>
          
</Grid>
                </Grid>
<Divider/>
<br/>
            <Grid container spacing={0}>
            <Grid item xs={7} align="left" style={{paddingLeft:0}}>
            <span><b>Class: </b>{chosen.class_} </span> <br/>
            <span><b>Number On Roll: </b>{students.length!==0?students.filter(bug=>(bug.class_===chosen.class_) && (bug.status==="Active")).length:0} </span> <br/>
           <span><b>Date: </b>{months[parseInt((date.split("-"))[1])-1] +" "+(date.split("-"))[2]+", "+(date.split("-"))[0] }</span>
            </Grid>  

            <Grid item xs={5} align="left">
          
            
            <span><b>Term: </b>{(() => {
                const country = schooldata?.country || 'GH';
                return getTermDisplay(selectedterm, country);
            })()}</span> <br/>
            <span><b>Re-opening Date:</b> {schooldata.reopendate!==""?months[parseInt((schooldata.reopendate.split("-"))[1])-1] +" "+(schooldata.reopendate.split("-"))[2]+", "+(schooldata.reopendate.split("-"))[0]:"Set Re-opening Date"} </span>
            </Grid>

            </Grid>

                </div>

                   </div> 
                   
                    <Tablereport
                      data={
                        selectedterm !== "none"
                          ? chosen !== undefined
                            ? chosen.academic
                                .filter(bug => bug.term === selectedterm)
                                .filter(subject => subject.type?.toLowerCase?.() !== 'special exams')
                            : []
                          : []
                      }
                    />

    <Divider/>
<br/>
                    {/* Special Exams Table (toggleable with dummy data fallback) */}
                    {specialExams && (() => {
                      const country = schooldata?.country || 'GH';
                      const termKey = selectedterm;
                      const termDisplay = getTermDisplay(selectedterm, country);

                      // Dummy data shown if no real data is found
                      const dummySpecialExams = [
                        { subject: 'Math Special', total: 88, remarks: 'Excellent', term: termKey },
                        { subject: 'Science Special', total: 76, remarks: 'Good', term: termKey },
                        { subject: 'English Special', total: 82, remarks: 'Very Good', term: termKey },
                      ];

                      const matchesTerm = (att) => {
                        const t = att?.term || att?.termId || att?.termName;
                        return (
                          t === termKey ||
                          t === termDisplay ||
                          getTermDisplay(t, country) === termDisplay
                        );
                      };

                      const specialFromArray = (arr = []) =>
                        arr.filter(att =>
                          matchesTerm(att) &&
                          (att.type?.toLowerCase?.() === 'special exams' || att.type === 'special' || att.type === 'specialExam' || att.category === 'special')
                        );

                      const fromSpecialExams = specialFromArray(chosen?.specialExams);
                      const fromAcademic = specialFromArray(chosen?.academic);
                      const fromAcademics2 = specialFromArray(chosen?.academics2);

                      let specialData = [
                        ...fromSpecialExams,
                        ...fromAcademic,
                        ...fromAcademics2
                      ];

                      // If no real data, use dummy for the selected term
                      if (specialData.length === 0) {
                        specialData = dummySpecialExams;
                      }

                      const dataForTable = selectedterm === "none" ? [] : specialData;

                      return (
                        <>
                          <p style={{ textAlign: "center", color: "#1976d2", fontWeight: 700, letterSpacing: 1 }}>
                            SPECIAL EXAMS
                          </p>
                          <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 12 }}>
                            <thead>
                              <tr>
                                <th style={{ border: "1px solid #1976d2", background: "#e3f0ff", color: "#1976d2", fontWeight: 700, fontSize: 12, padding: 6, textAlign: "left" }}>Subject</th>
                                <th style={{ border: "1px solid #1976d2", background: "#e3f0ff", color: "#1976d2", fontWeight: 700, fontSize: 12, padding: 6, textAlign: "center" }}>Score</th>
                                <th style={{ border: "1px solid #1976d2", background: "#e3f0ff", color: "#1976d2", fontWeight: 700, fontSize: 12, padding: 6, textAlign: "left" }}>Remarks</th>
                              </tr>
                            </thead>
                            <tbody>
                              {dataForTable.length === 0 && (
                                <tr>
                                  <td colSpan={3} style={{ border: "1px solid #1976d2", padding: 6, fontSize: 12, textAlign: "center", color: "#666" }}>
                                    No special exams available
                                  </td>
                                </tr>
                              )}
                              {dataForTable.map((att, idx) => {
                                const subject = att.subject || att.subjectName || att.subjectId || att.name || `Subject ${idx + 1}`;
                                const score = formatNumber(
                                  att.total ??
                                  att.score ??
                                  att.exam_score ??
                                  att.examscore ??
                                  att.classscore ??
                                  att.value ??
                                  att.mark ??
                                  att.marks ??
                                  att.percentage ??
                                  0
                                );
                                const remarks = att.remarks || att.comment || att.note || att.result || "";
                                return (
                                  <tr key={idx}>
                                    <td style={{ border: "1px solid #1976d2", padding: 6, fontSize: 12 }}>{subject}</td>
                                    <td style={{ border: "1px solid #1976d2", padding: 6, fontSize: 12, textAlign: "center" }}>{score}</td>
                                    <td style={{ border: "1px solid #1976d2", padding: 6, fontSize: 12 }}>{remarks}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                          <Divider/>
                          <br/>
                        </>
                      );
                    })()}
                    {/* Domain Assessment (optional) */}
                    {showDomainAssessment && (() => {
                        // Support both academic and academics2 (bulk) structures
                        const findDomain = () => {
                          const rec = chosen?.academic?.find(att => att.term === selectedterm);
                          if (rec?.domainAssessment) return rec.domainAssessment;
                          const rec2 = chosen?.academics2?.find?.(att => att.term === selectedterm);
                          return rec2?.domainAssessment;
                        };
                        const domainData = findDomain();
                        const affective = domainData?.affective || {};
                        const psychomotor = domainData?.psychomotor || {};
                        const hasDomain = Object.keys(affective).length || Object.keys(psychomotor).length;
                        if (!hasDomain) return null;
                        return (
                          <>
                            <p style={{ textAlign:"center", color:"#1976d2", fontWeight:700, letterSpacing:1 }}>DOMAIN ASSESSMENT</p>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={6}>
                                <div style={{ marginBottom: 12 }}>
                                  <div style={{ fontWeight:600, color:"#1976d2", marginBottom:6, textAlign:"center" }}>AFFECTIVE DOMAIN</div>
                                  <table style={{ width:"100%", borderCollapse:"collapse" }}>
                                    <thead>
                                      <tr>
                                        <th style={{ border:"1px solid #1976d2", background:"#e3f0ff", color:"#1976d2", fontWeight:700, fontSize:12, padding:3, textAlign:"left" }}>Trait</th>
                                        <th style={{ border:"1px solid #1976d2", background:"#e3f0ff", color:"#1976d2", fontWeight:700, fontSize:12, padding:3, width:40, textAlign:"center" }}>Score</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {Object.keys(affective).map(key => (
                                        <tr key={key}>
                                          <td style={{ border:"1px solid #1976d2", padding:4, fontSize:12 }}>{key}</td>
                                          <td style={{ border:"1px solid #1976d2", padding:4, fontSize:12, textAlign:"center" }}>{formatNumber(affective[key])}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <div style={{ marginBottom: 12 }}>
                                  <div style={{ fontWeight:600, color:"#1976d2", marginBottom:6, textAlign:"center" }}>PSYCHOMOTOR DOMAIN</div>
                                  <table style={{ width:"100%", borderCollapse:"collapse" }}>
                                    <thead>
                                      <tr>
                                        <th style={{ border:"1px solid #1976d2", background:"#e3f0ff", color:"#1976d2", fontWeight:700, fontSize:12, padding:3, textAlign:"left" }}>Skill</th>
                                        <th style={{ border:"1px solid #1976d2", background:"#e3f0ff", color:"#1976d2", fontWeight:700, fontSize:12, padding:3, width:40, textAlign:"center" }}>Score</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {Object.keys(psychomotor).map(key => (
                                        <tr key={key}>
                                          <td style={{ border:"1px solid #1976d2", padding:4, fontSize:12 }}>{key}</td>
                                          <td style={{ border:"1px solid #1976d2", padding:4, fontSize:12, textAlign:"center" }}>{formatNumber(psychomotor[key])}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </Grid>
                            </Grid>
                            <Divider />
                            <br/>
                          </>
                        );
                    })()}

                    <Grid container spacing={0}>

                    <Grid item xs={8}>
                    <b>Total Score: {formatNumber(chosen!==undefined?selectedterm !== "none" && selectedterm !== undefined ? chosen.academic.length!==0 && chosen.academic.filter(bug=> bug.term === selectedterm).length !==0? chosen.academic.length!==0 && chosen.academic.filter(bug=> bug.term === selectedterm)[0].totalscore:0:0:0)}</b><br/>
                    {showAggregate && (Class_.filter(bug=>bug.classname === chosen.class_).length!==0 ? Class_.filter(bug=>bug.classname === chosen.class_)[0].aggregate===true && <b>Aggregate: {formatNumber(chosen!==undefined?selectedterm !== "none" && selectedterm !== undefined && chosen.academic.filter(bug=> bug.term === selectedterm).length !==0 ? selectedterm !== undefined &&  chosen.academic.filter(bug=> bug.term === selectedterm)[0].aggregate :0:0)}</b>:0)}
                    </Grid>

                    <Grid item xs={4}>
                    {showPositionFlag && Class_.filter(bug=>bug.classname === chosen.class_).length!==0 && Class_.filter(bug=>bug.classname === chosen.class_)[0].position===true && <b style={{color:"red"}}>Position in class: { formatNumber(chosen!==undefined?selectedterm !== "none" && selectedterm !== undefined && chosen.academic.length!==0 && chosen.academic.filter(bug=> bug.term === selectedterm).length !==0 ?  chosen.academic.filter(bug=> bug.term === selectedterm)[0].position:"-":0)} <br/></b>}
                    
                   {showPromotion && (() => {
                       const country = schooldata?.country || 'GH';
                       const termString = selectedterm ? getTermDisplay(selectedterm, country) : '';
                       return termString && termString.split(" Term ")[0]==="3rd" &&  <div><b>Promoted to: {chosen!==undefined? selectedterm !== "none" && selectedterm !== undefined && chosen.academic.length!==0 && chosen.academic.filter(bug=> bug.term === selectedterm).length !==0 ? chosen.academic.length!==0 && chosen.academic.filter(bug=> bug.term === selectedterm)[0].promotion:"-":0}</b><br/></div>;
                   })()}
                    
                    </Grid>

                    </Grid>
                    <br/>
                    <Divider/>
                   <br/>
                    {/* <p align="center"> NEXT TERM FEES </p> */}
                    <Grid container spacing={0} >

                    <Grid item xs={4}>
                    <b>Interest : </b>
                    </Grid> 
                    <Grid item xs={8}>
                    {chosen!==undefined?selectedterm !== "none" && selectedterm !== undefined ? chosen.academic.length!==0 && chosen.academic.filter(bug=> bug.term === selectedterm).length !==0? chosen.academic.length!==0 && chosen.academic.filter(bug=> bug.term === selectedterm)[0].interest:"":"":""} 
                    </Grid>
                   

 
                    <Grid item xs={4}>
                    <b>Conduct / Character : </b> 
                    </Grid> 
                    <Grid item xs={8}>
                    {chosen!==undefined?selectedterm !== "none" && selectedterm !== undefined ? chosen.academic.length!==0 && chosen.academic.filter(bug=> bug.term === selectedterm).length !==0? chosen.academic.length!==0 && chosen.academic.filter(bug=> bug.term === selectedterm)[0].conduct:"":"":""}
                    </Grid>

 
                    <Grid item xs={4}>
                    <b>Class Teacher's Remarks : </b> 
                    </Grid> 
                    <Grid item xs={8}>
                    {chosen!==undefined?selectedterm !== "none" && selectedterm !== undefined ? chosen.academic.length!==0 && chosen.academic.filter(bug=> bug.term === selectedterm).length !==0? chosen.academic.length!==0 && chosen.academic.filter(bug=> bug.term === selectedterm)[0].teacherremarks:"":"":""}
                    </Grid>

 
                    {/* <Grid item xs={4}>
                    <b>Head Teacher's Remarks : </b>
                    </Grid> 
                    <Grid item xs={8}>
                    {chosen!==undefined?selectedterm !== "none" && selectedterm !== undefined ? chosen.academic.length!==0 && chosen.academic.filter(bug=> bug.term === selectedterm).length !==0? chosen.academic.length!==0 && chosen.academic.filter(bug=> bug.term === selectedterm)[0].headremarks:"":"":""}
                    </Grid> */}

 
                  <br/> 
                   
                
                 
                     
                    <Grid item xs={8}>
                    
                  
                    <p style={{marginTop:40}}>Head Teacher's Signature..................................................</p>
                    
                    {/* <p style={{fontWeight:"bold", margin:2, fontStyle:'italic'}}>Class Teacher : {Class_.filter(bug=>bug.classname === chosen.class_).length!==0 && Class_.filter(bug=>bug.classname === chosen.class_)[0].classteacher}</p> */}
                    {/* <p style={{fontWeight:"bold", margin:2, fontStyle:'italic'}}>Class Teacher</p> */}
                    </Grid>     
                    
                    <Grid item xs={4}>
                    
                    </Grid>
                    
                      
                 

                    </Grid>
<Divider/>
<small>
<p style={{textAlign:"center"}}>INTERPRETATION OF GRADING SYSTEM</p>
<Grid container>
{schooldata.grades.map((list, index)=>

<Grid item xs={4}>{list.remarks+" = "+list.upperlimit+" - "+list.lowerlimit} </Grid>

)}
</Grid>
</small>


        </Container>
        </div>
    
       

        </div>
    );
     
    }
}

export default Printpage;
